import { render } from "./Button.vue?vue&type=template&id=2c55fb49&ts=true"
import script from "./Button.vue?vue&type=script&setup=true&lang=ts"
export * from "./Button.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/button/Button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c55fb49"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c55fb49', __exports__)) {
    api.reload('2c55fb49', __exports__)
  }
  
  module.hot.accept("./Button.vue?vue&type=template&id=2c55fb49&ts=true", () => {
    api.rerender('2c55fb49', render)
  })

}


export default __exports__